/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Vast_Pure_Buck_NoteInputs */

const en_vast_pure_buck_note = /** @type {(inputs: Vast_Pure_Buck_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Topic classification in progress`)
};

const de_vast_pure_buck_note = /** @type {(inputs: Vast_Pure_Buck_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Themenklassifizierung läuft`)
};

/**
* | output |
* | --- |
* | "Topic classification in progress" |
*
* @param {Vast_Pure_Buck_NoteInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const vast_pure_buck_note = /** @type {((inputs?: Vast_Pure_Buck_NoteInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Vast_Pure_Buck_NoteInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_vast_pure_buck_note(inputs)
	return de_vast_pure_buck_note(inputs)
});